export const CUSTOMER_LIST_START = "CUSTOMER_LIST_START";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_ERROR = "CUSTOMER_LIST_ERROR";
export const CUSTOMER_DETAIL_START  = "CUSTOMER_DETAIL_START";
export const CUSTOMER_DETAIL_SUCCESS = "CUSTOMER_DETAIL_SUCCESS";
export const CUSTOMER_DETAIL_ERROR = "CUSTOMER_DETAIL_ERROR";
export const CUSTOMER_BOOKING_LIST_START = "CUSTOMER_BOOKING_LIST_START";
export const CUSTOMER_UT_BOOKING_LIST_SUCCESS = "CUSTOMER_UT_BOOKING_LIST_SUCCESS"
export const CUSTOMER_OT_BOOKING_LIST_SUCCESS = "CUSTOMER_OT_BOOKING_LIST_SUCCESS"
export const CUSTOMER_CT_BOOKING_LIST_SUCCESS = "CUSTOMER_CT_BOOKING_LIST_SUCCESS"
export const CUSTOMER_CNT_BOOKING_LIST_SUCCESS = "CUSTOMER_CNT_BOOKING_LIST_SUCCESS"
export const CUSTOMER_BOOKING_LIST_ERROR = "CUSTOMER_BOOKING_LIST_ERROR"